/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppAccountUpdateBusinessProfile } from '../../axios/whatsAppAccountUpdateBusinessProfile'
import type {
	WhatsAppAccountUpdateBusinessProfileError,
	WhatsAppAccountUpdateBusinessProfilePathParams,
	WhatsAppAccountUpdateBusinessProfileRequest,
	WhatsAppAccountUpdateBusinessProfileResponse,
} from '../../types/WhatsAppAccountUpdateBusinessProfile'

export const whatsAppAccountUpdateBusinessProfileMutationKey = () =>
	[{ url: '/organisations/:organisationId/whatsapp-account/business-profile' }] as const

export type WhatsAppAccountUpdateBusinessProfileMutationKey = ReturnType<
	typeof whatsAppAccountUpdateBusinessProfileMutationKey
>

export type WhatsAppAccountUpdateBusinessProfileVariables = {
	organisationId: WhatsAppAccountUpdateBusinessProfilePathParams['organisationId']
	data: WhatsAppAccountUpdateBusinessProfileRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAccountController.php WhatsAppAccountController::updateBusinessProfile */
export function useWhatsAppAccountUpdateBusinessProfile<TContext = unknown>(
	options?: UseMutationOptions<
		WhatsAppAccountUpdateBusinessProfileResponse,
		AxiosError<WhatsAppAccountUpdateBusinessProfileError>,
		WhatsAppAccountUpdateBusinessProfileVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: whatsAppAccountUpdateBusinessProfileMutationKey(),
		mutationFn: ({ organisationId, data }: WhatsAppAccountUpdateBusinessProfileVariables) =>
			whatsAppAccountUpdateBusinessProfile(organisationId, data, config).then(res => res.data),
		...options,
	})
}
